"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopeLevelArr = exports.SCOPE_LEVEL_ADMIN = exports.SCOPE_LEVEL_SUPER = exports.TE_ROOT_USER = exports.SERVICE_ACCOUNT = void 0;
var permission_enum_1 = require("../enums/permission.enum");
exports.SERVICE_ACCOUNT = 'SERVICE_ACCOUNT'; // M2M SCOPE FOR SUPER ACCESS ACROSS ORGANIZATIONS
exports.TE_ROOT_USER = 'TE_ROOT_USER'; // USER SCOPE FOR SUPER ACCESS ACROSS ORGANIZATIONS
exports.SCOPE_LEVEL_SUPER = permission_enum_1.EScopeLevel.SUPER;
exports.SCOPE_LEVEL_ADMIN = permission_enum_1.EScopeLevel.ADMIN;
exports.ScopeLevelArr = [permission_enum_1.EScopeLevel.ADMIN, permission_enum_1.EScopeLevel.SUPER];
